export default __webpack_public_path__ + "c099b535c989e9b43f29527700f723da.png";